import { createAction } from '@reduxjs/toolkit';
import { CusatSortField } from 'constants/cusat';
import { storeName } from '../config';

export const changeSort = createAction<CusatSortField>(
  `${storeName}/changeSort`,
);
